<div class="row text-center">
  <div class="col-md-4">
    <mat-button-toggle-group aria-label="Tipo">
      <mat-button-toggle mwlCalendarPreviousView value="Previous" [view]="view" [(viewDate)]="viewDate"
        (viewDateChange)="closeOpenMonthViewDay()">Anterior</mat-button-toggle>
      <mat-button-toggle mwlCalendarToday [(viewDate)]="viewDate" value="Today">Hoje</mat-button-toggle>
      <mat-button-toggle mwlCalendarNextView value="Next" [view]="view" [(viewDate)]="viewDate"
        (viewDateChange)="closeOpenMonthViewDay()">Próximo</mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <div class="col-md-4">
    <h3>{{ viewDate | calendarDate : view + 'ViewTitle' : 'pt-BR' }}</h3>
  </div>

  <div class="col-md-4">
    <mat-button-toggle-group aria-label="Tipo">
      <mat-button-toggle (click)="setView(CalendarView.Month)" value="Month"
        [class.active]="view === CalendarView.Month">Mês</mat-button-toggle>
      <mat-button-toggle (click)="setView(CalendarView.Week)" value="Week" [class.active]="view === CalendarView.Week"
        *ngIf="!mobile">Semana</mat-button-toggle>
      <mat-button-toggle (click)="setView(CalendarView.Day)" value="Day"
        [class.active]="view === CalendarView.Day">Dia</mat-button-toggle>
    </mat-button-toggle-group>
  </div>
</div>

<ng-template #customMonthCell let-day="day">
  <div class="cal-day-cell custom-cell" (pointerdown)="onDayMouseDown(day.date)" (pointerup)="onDayMouseUp()"
    (pointerleave)="onDayMouseUp()">
    <div class="day-content">
      <div class="event-count" *ngIf="day.events.length > 0">
        {{ day.events.length }}
      </div>

      <div class="day-number">{{ day.date | date : 'd' }}</div>

      <div class="day-label" *ngIf="getModifiedDayType(day.date) as type">
        <span class="badge" [ngClass]="{ holiday: type === 'holiday', block: type === 'blockSchedule' }">
          {{ getLabelByType(type) }}
        </span>
      </div>
    </div>
  </div>
</ng-template>

<div [ngSwitch]="view">
  <mwl-calendar-month-view *ngSwitchCase="CalendarView.Month" [viewDate]="viewDate" [events]="events"
    [refresh]="refresh" [cellTemplate]="customMonthCell" [activeDayIsOpen]="activeDayIsOpen"
    (dayClicked)="dayClicked($event.day)" [draggable]="false" class="no-drag-cursor">
  </mwl-calendar-month-view>
  <mwl-calendar-week-view *ngSwitchCase="CalendarView.Week" [viewDate]="viewDate" [events]="events" [refresh]="refresh"
    [draggable]="false" class="no-drag-cursor">
  </mwl-calendar-week-view>
  <mwl-calendar-day-view *ngSwitchCase="CalendarView.Day" [viewDate]="viewDate" [events]="events" [refresh]="refresh"
    [draggable]="false" class="no-drag-cursor">
  </mwl-calendar-day-view>
</div>

<div class="info-legend mt-3 mb-4">
  <h4>
    <i class="fas fa-info-circle"></i> Dica
  </h4>
  <p>
    Para bloquear um dia ou marcá-lo como feriado, pressione o dia desejado por 3 segundos. Um formulário será exibido
    para configuração.
  </p>
</div>

<div class="event-legend mt-3 mb-4">
  <h4>Legenda dos Eventos</h4>
  <ul>
    <li><b>Consulta</b> (azul): Atendimento especialista com horário agendado.</li>
    <li><b>Exame</b> (amarelo): Procedimento laboratorial ou de imagem.</li>
    <li><b>Especialista</b>: Nome do profissional responsável.</li>
    <li><b>Procedimento</b>: Tipo da consulta ou exame agendado.</li>
    <li><b>Paciente</b>: Nome da pessoa atendida.</li>
    <li><b>Hora</b>: Horário de início do atendimento.</li>
  </ul>
</div>